((app) => {
    app.factory("searchService", function () {
            let service = {};
            let _searchTerm = "";
            let _carrierFilter = null;
            let _productFilter = null;
            let _productTypeFilter = null;
            let _callbacks = [];

            service.set = (term) => {
                _searchTerm = term;
            };

            service.getTerm = () => {
                return _searchTerm;
            };

            service.reset = () => {
                _searchTerm = "";
                _notify();
            };

            service.register = (observer) => {
                _callbacks.push(observer);
            };

            service.setFilters = (carrier, product, productType) => {
                _carrierFilter = carrier;
                _productFilter = product;
                _productTypeFilter = productType;
            };

            service.getFilters = () => {
                let filters = [];
                filters.push(_carrierFilter);
                filters.push(_productFilter);
                filters.push(_productTypeFilter);
                return filters;
            };

            function _notify() {
                _callbacks.forEach(callback => callback());
            }

            return service;
        }
    );
})(window.app);